import { render, staticRenderFns } from "./m-header-nav.vue?vue&type=template&id=1307c57a&scoped=true&"
import script from "./m-header-nav.vue?vue&type=script&lang=js&"
export * from "./m-header-nav.vue?vue&type=script&lang=js&"
import style0 from "./m-header-nav.vue?vue&type=style&index=0&id=1307c57a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1307c57a",
  null
  
)

export default component.exports